<template>
  <div>

        <div class="container" v-if="loaded">

        
            <div class="factsheet-caution-notice">
          
          
            <p><strong><i class="bi bi-exclamation-circle" style="font-size:1.5em;float:left;margin-right:8px;"></i> This is a development version for reviewing purposes.</strong></p>
            <p>
                The mountain factsheets are designed to be viewed in PDF format, which is done as a separate postprocessing step. You may 
                use the online factsheet below to check and verify all the data and maps that are created as part of the processing. 
            </p>
            <p v-if="factsheet.data.mountain_postprocessing">
                You can view the <a :href="urlFor('mountain_postprocessing/'+factsheet.data.mountain_postprocessing.pdf)">PDF version of this factsheet</a> for a preview of the final results.
            </p>
            <p v-else>
                The PDF document has not been processed yet for this area, please check back soon.
            </p>
          
        </div>

            <div class="row align-items-center">
                <div class="col-7">
                    <h2>Table of Contents</h2>
                    <ul id="toc" class="collapsed">
                        <li><a href="#summary"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 1. General Information</a></li>
                        <li><a href="#landcover"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 2. Land Cover and Land Use</a></li>
                        <li><a href="#topography"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 3. Topography</a></li>
                        <li><a href="#climate"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 4. Climate</a></li>
                        <li><a href="#hydrology"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 5. Hydrology and Water Resources</a></li>
                        <li><a href="#cryosphere"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 6. Cryosphere</a></li>
                        <li><a href="#data"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 7. Data and Measurement Locations</a></li>
                        <li><a href="#notes"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> Notes</a></li>
                        <li><a href="#references"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> References</a></li>
                    </ul>
                </div>
                <div class="col-5">
                    
                </div>
            </div>

        <div class="row align-items-top">
            <div class="col-8">
                <img :src="urlFor('mountain_summary/Cloudless.png')" style="width:100%" />
            </div>
            <div class="col-4">
            <img :src="urlFor('mountain_summary/Overview.png')" style="width:100%" /><br /><br />
                <img :src="urlFor('mountain_summary/OverviewLocal.png')" style="width:100%" />
            </div>

        </div>

        </div>

        <Summary v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />

        <Landcover v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />

        <Topography v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />

        <Climate v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />

        <Hydrology v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />

        <Cryosphere v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />

        <Data v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />

        <References v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />


        
  </div>
</template>

<script>
/* eslint-disable */
  import _ from 'lodash'; 

  import Summary from '@/components/factsheet/mountain/Summary.vue'
  import Economics from '@/components/factsheet/mountain/Economics.vue'
  import Topography from '@/components/factsheet/mountain/Topography.vue'
  import Landcover from '@/components/factsheet/mountain/Landcover.vue'
  import Climate from '@/components/factsheet/mountain/Climate.vue'
  import Hydrology from '@/components/factsheet/mountain/Hydrology.vue'
  import Cryosphere from '@/components/factsheet/mountain/Cryosphere.vue'
  import Data from '@/components/factsheet/mountain/Data.vue'
  import References from '@/components/factsheet/mountain/References.vue'
  
  import omnivore from "@mapbox/leaflet-omnivore";
  
  export default {
    name: 'factsheetmountain',
    props: ['location', 'factsheet', 'loaded'],
    components: {
        Summary, Economics, Topography, Landcover, Climate, Hydrology, Cryosphere, Data, References
    },
    data() {
        return {
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
      urlFor(asset) {
        return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/'+asset;
      },
    }
  }
</script>


<style>
body {
    color:#666;
}
div.factsheet {
    font-size:1.5em;
}

div.factsheet h1 {
    font-size:1.3em;
    font-weight:600;
    margin-top:15px;
}

div.factsheet h2 {
    font-size:1.2em;
    font-weight:600;
    margin-top:15px;
}

div.factsheet h3 {
    font-size:1.05em;
    font-weight:600;
    margin-top:15px;
}

div.factsheet p {
    line-height:1.4em;
}

div.factsheet ul li {
    padding:7px 0px 7px 0px;
}

div.factsheet table td {
    color:#666;
    line-height:1.4em;
}

ul.collapsed {
    list-style-type:none;
    margin-left:0px;
    padding-left:0px;
    margin-bottom:5px;
}
ul.collapsed li {
    margin-left:0px;
}

div.data-availability ul {
    list-style-type:none;
    margin-left:0px;
    padding-left:0px;
    margin-bottom:5px;
}
div.data-availability ul li {
    margin-left:0px;
}
div.factsheet-status-error {
    margin:20px 0px;
    padding:20px 20px 6px 20px;
    font-size:0.8em;
    border-radius:0px;
    color:#e50000;
    border:2px solid #e50000;
    background-color:#fff0f0;
}
div.factsheet-status-ok {
    margin:20px 0px;
    padding:20px 20px 6px 20px;
    font-size:0.8em;
    border-radius:0px;
    color:#378c07;
    border:2px solid #15b01a;
    background-color:#e8fae9
}
div.factsheet-status-notice {
    margin:20px 0px;
    padding:20px 20px 6px 20px;
    font-size:0.8em;
    border-radius:0px;
    color:#666;
    border:2px solid #ffd152;
    background-color:#ffffe4
}
</style>
